import {PolymerElement} from '@polymer/polymer/polymer-element.js';
import {html} from '@polymer/polymer/lib/utils/html-tag.js';
import template from './ns-yes-no.html';
import '../ns-radio-button/ns-radio-button.html'

/**
 * The ns-yes-no should be used to allow a user to indicate a yes or no choice.
 *
 * <h1>Yes/No Radio</h1>
 * <demo-snippet class="demoSnippet">
 *   <template>
 *     <ns-yes-no></ns-yes-no>
 *   </template>
 * </demo-snippet>
 *
 */
export class NsYesNo extends PolymerElement {
    constructor() {
        super();
    }

    static get is() {
        return "ns-yes-no";
    }

    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
    htmlElement.innerHTML = template;
    return htmlElement;
    }

    static get properties() {
        return {
            /**
             * id is used to target the yes/no block of code specifically
             */
            id: String,
            /**
             * title is used to display the title of the section. By default, it is "Yes or No"
             */
            title: {
                type: String,
                value: "Yes or No"
            },
            /**
             * yes is used by default for both the value and the label
             */
            yes: {
                type: String,
                value: "Yes"
            },
            /**
             * no is used by default for both the value and the label
             */
            no: {
                type: String,
                value: "No"
            }
        };
    }

    ready() {
        super.ready();
        console.log('Yes / No Ready:', this.title);
    }

    toggleRadio(e) {
        var nameGroup = this.$.radioButtons.children;
        for(var i = 0; i < nameGroup.length; i++) {
            nameGroup[i].checked = false;
        }
        this.checked = true;
    }

}
customElements.define(NsYesNo.is, NsYesNo);